export default __webpack_public_path__ + "static/media/payment-method-mobile-active.d22af564.svg";